import * as RDD from 'react-device-detect';
import { getFingerprintDeviceId } from './fingerprintUtils';
import { isDegradedMobileExperience } from './mobileUtils';
import { getIsWebGlSupportedViaCanvasContext, getIsWebGlSupportedViaPixiUtil, getWebGlParameters } from './webGlUtils';
export const RDD_LABELS = {
    browserName: 'Browser Name',
    fullBrowserVersion: 'Full Browser Version',
    isMobile: 'Is Mobile',
    isTablet: 'Is Tablet',
    isAndroid: 'Is Android',
    isIOS: 'Is iOS',
    isChrome: 'Is Chrome',
    isSafari: 'Is Safari',
    isMobileSafari: 'Is Mobile Safari',
    isMacOs: 'Is macOS',
    isWindows: 'Is Windows'
};
export function getDeviceDetectInfo() {
    const deviceDetect = {};
    const fingerprintDeviceId = getFingerprintDeviceId();
    if (fingerprintDeviceId) {
        deviceDetect['Device ID'] = fingerprintDeviceId;
    }
    Object.keys(RDD_LABELS).forEach((rddKeyStr) => {
        const rddKey = rddKeyStr;
        const selectorResult = RDD[rddKey];
        if (selectorResult) {
            // we only care if the flag is true, to cut down on noise
            deviceDetect[RDD_LABELS[rddKey]] = selectorResult;
        }
    });
    deviceDetect['Browser Window Dimensions'] = `${window.innerWidth}x${window.innerHeight}`;
    deviceDetect['Screen Resolution (physical)'] =
        `${Math.round(window.screen.width * window.devicePixelRatio)}x${Math.round(window.screen.height * window.devicePixelRatio)}`;
    deviceDetect['Screen Resolution (logical)'] = `${window.screen.width}x${window.screen.height}`;
    deviceDetect['Device Pixel Ratio'] = window.devicePixelRatio;
    if (isDegradedMobileExperience()) {
        deviceDetect['Is Degraded Mobile Experience'] = true;
    }
    deviceDetect['WebGL support (via PIXI.utils)'] = getIsWebGlSupportedViaPixiUtil();
    deviceDetect['WebGL support (via canvas context)'] = getIsWebGlSupportedViaCanvasContext();
    Object.entries(getWebGlParameters()).forEach(([key, value]) => {
        deviceDetect[key] = value;
    });
    return deviceDetect;
}
export function isReactNative() {
    return !!window.isReactNative;
}
